<div class="home-layout">
  <!-- Left Banner -->
  <aside class="banner-area left">
    <app-side-banner [banner]="getBanner('left')"></app-side-banner>
  </aside>

  <!-- Main Content -->
  <main class="main-content">
    <app-filter-panel
      (filterChanged)="onFilterChanged($event)"
      (resetFilters)="onResetFilters()"
      (areaModalApplied)="onAreaModalApplied($event)">
    </app-filter-panel>

    <!-- DEFAULT STATE -->
    @if (!isFiltered()) {
      <!-- Residential Complexes -->
      <section class="section">
        <div class="section-header">
          <h2 class="section-title">Yaşayış kompleksləri</h2>
          <a routerLink="/complexes" class="see-more">Daha çox <i class="fas fa-chevron-right"></i></a>
        </div>

        <div class="complexes-grid">
          @if (loadingComplexes()) {
            @for (i of [1,2,3,4]; track i) {
              <app-skeleton-card></app-skeleton-card>
            }
          } @else {
            @for (complex of complexes(); track complex.id) {
              <app-complex-card [complex]="complex"></app-complex-card>
            }
          }
        </div>
      </section>

      <!-- VIP Listings -->
      <section class="section">
        <div class="section-header">
          <h2 class="section-title">VIP elanlar</h2>
        </div>

        <div class="listings-grid">
          @for (listing of vipListings(); track listing.id) {
            <app-listing-card [listing]="listing"></app-listing-card>
          }

          @if (loadingVip()) {
            @for (i of [1,2,3,4]; track i) {
              <app-skeleton-card></app-skeleton-card>
            }
          }
        </div>
      </section>

      <!-- Latest Listings -->
      <section class="section">
        <div class="section-header">
          <h2 class="section-title">Son elanlar</h2>
        </div>

        <div class="listings-grid">
          @for (listing of allListings(); track listing.id) {
            <app-listing-card [listing]="listing"></app-listing-card>
          }

          @if (loadingAll()) {
            @for (i of [1,2,3,4]; track i) {
              <app-skeleton-card></app-skeleton-card>
            }
          }
        </div>
      </section>
    }

    <!-- FILTERED STATE -->
    @if (isFiltered()) {
      <section class="section">
        <div class="section-header">
          <h2 class="section-title">Bütün elanlar</h2>
        </div>

        <div class="listings-grid">
          @for (listing of allListings(); track listing.id) {
            <app-listing-card [listing]="listing"></app-listing-card>
          }

          @if (loadingAll()) {
            @for (i of [1,2,3,4]; track i) {
              <app-skeleton-card></app-skeleton-card>
            }
          }

          @if (!loadingAll() && allListings().length === 0) {
            <div class="empty-state">
              <i class="fas fa-search"></i>
              <p>Uyğun elan tapılmadı</p>
            </div>
          }
        </div>
      </section>
    }
  </main>

  <!-- Right Banner -->
  <aside class="banner-area right">
    <app-side-banner [banner]="getBanner('right')"></app-side-banner>
  </aside>
</div>
